module.exports = __webpack_public_path__ + "img/arrow-primary.d9186fe0.svg";